module.exports = function() {
  return new Worker(__webpack_public_path__ + "c632732fc0a1483f7a47.worker.js");
};